// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"68a4f96d","799":"1915905e","896":"5c71aba7"}[chunkId] + ".chunk.js";
};